<template>
  <Container>
    <div class="space-y-20px">
      <Heading
        v-if="hasSlot('title')"
        :headingTag="'h2'"
        :style="'h2'"
        bottomSpacing>
        <slot name="title"></slot>
      </Heading>
      <Paragraphs v-if="body" isHighlight :text="body"> </Paragraphs>
      <Grid
        :isLastColCenter="mergedGridOptions.isLastColCenter"
        :numCols="mergedGridOptions.numCols"
        :showBorder="mergedGridOptions.showBorder"
        :colWidth="mergedGridOptions.colWidth">
        <slot></slot>
      </Grid>
      <div class="mt-40px text-center" v-if="button">
        <Button :style="'primary'" :tag="'a'" :link="button.link">{{
          button.text
        }}</Button>
      </div>
    </div>
  </Container>
</template>

<script>
import useHasSlot from "../../compostables/useHasSlot";
import { computed } from "@vue/runtime-core";

import Button from "../Atoms/Button.vue";
import Container from "../Atoms/Container.vue";
import Grid from "../Atoms/Grid/GridContainer.vue";
import Paragraphs from "../Atoms/ParagraphsNew.vue";
import Heading from "../Atoms/Heading.vue";

export default {
  components: {
    Button,
    Container,
    Grid,
    Paragraphs,
    Heading,
  },

  props: {
    button: {
      type: Object,
      required: false,
    },
    body: {
      type: String,
      required: false,
    },
    gridOptions: {
      type: Object,
      required: false,
    },
  },

  setup(props, { slots }) {
    // Merge defaults with props
    const mergedGridOptions = computed(() => ({
      ...{
        isLastColCenter: false,
        numCols: 3,
        showBorder: false,
        colWidth: "normal",
      },
      ...props.gridOptions,
    }));

    const { hasSlot } = useHasSlot(slots);

    return {
      hasSlot,
      mergedGridOptions,
    };
  },
};
</script>
